import { NotifyHelper } from 'classes/helpers/notify.helper';
import { WebSocketHelper } from 'classes/helpers/web-socket.helper';
import { WsMsgType } from 'lib_ts/enums/machine-msg.enum';
import { IGameStatusMsg } from 'lib_ts/interfaces/machine-msg/i-game-status';
import { useEffect } from 'react';
import { WebSocketService } from 'services/web-socket.service';
import { useAuthStore } from 'stores/use-auth-store';

export const useGameStatusListeners = () => {
  const wsConnected = useAuthStore((s) => s.wsConnected);

  useEffect(() => {
    if (!wsConnected) {
      return;
    }

    const onGameStatus = (event: CustomEvent) => {
      const data: IGameStatusMsg = event.detail;

      NotifyHelper.debug({
        message_md: `Received game status message (${data.status}).`,
      });

      useAuthStore.getState().setIsInGame(data.status);
    };

    WebSocketHelper.on(WsMsgType.S2U_GameStatus, onGameStatus);

    WebSocketService.send(
      WsMsgType.U2S_GameStatus,
      {},
      'Game status listener is ready'
    );

    return () => {
      WebSocketHelper.remove(WsMsgType.S2U_GameStatus, onGameStatus);
    };
  }, [wsConnected]);
};
